import { useContext, useEffect } from 'react';

import { enableCheckOption } from '../../api';
import { ChecklistItems } from '../../api/configurations/checklist/types';
import { useNotifications } from '../../hooks/useNotifications';
import { updateProjectType } from '../../utils';
import { SettingsContext } from './context';
import { UpdateChecklistHook } from './types';

export const useChecklist = (projectId: string): UpdateChecklistHook => {
  const { setChecklistItems, checklistItems, currentProject, currentSocials } =
    useContext(SettingsContext);
  const { showErrorNotify } = useNotifications();

  const enableChecklistItem = async (itemName: string) => {
    try {
      if (checklistItems?.[itemName]) {
        return;
      }
      await enableCheckOption(projectId, itemName);
      setChecklistItems((prev) => {
        return {
          ...prev,
          [itemName]: true
        };
      });
    } catch (error) {
      showErrorNotify(error);
    }
  };

  useEffect(() => {
    const newProjectType = updateProjectType(currentProject, currentSocials);
    if (!newProjectType || !currentProject || !checklistItems) {
      return;
    }
    if (newProjectType) {
      enableChecklistItem(ChecklistItems.SELECTED_LOGIN_METHOD);
    }
    if (currentProject?.login_urls?.length > 1) {
      enableChecklistItem(ChecklistItems.SET_CALLBACK_URL);
    }
  }, [currentProject, checklistItems, currentSocials]);

  return {
    enableChecklistItem,
    checklistItems
  };
};
